export default function QuestionScreen({
  question,
  answers,
  onAnswer,
  onNext,
  onBack,
  current,
  total,
}) {
  if (!question) return null;

  const isMultiSelect =
    question.options.length > 1 && question.id !== "q1";

  return (
    <div className="screen">
      <div className="card">
        {/* Progress number */}
        <div className="progress-number">{current + 1}</div>

        {/* Question */}
        <h2 className="question-title">{question.title}</h2>

        {isMultiSelect && (
          <p className="undertitle">Meerdere antwoorden mogelijk</p>
        )}

        {/* Answers */}
        <div
          className={`options ${
            question.options.length === 3 ? "options--stacked" : ""
          }`}
        >
          {question.options.map((option) => (
            <button
              key={option.key}
              className={`option-button ${
                Array.isArray(answers[question.id]) &&
                answers[question.id].includes(option.key)
                  ? "is-selected"
                  : ""
              }`}
              onClick={() => onAnswer(question.id, option.key)}
            >
              <span className="option-icon">{option.icon}</span>
              <span className="option-text">{option.label}</span>
            </button>
          ))}
        </div>

        {/* Navigation buttons */}
        <div style={{ display: "flex", gap: "16px", marginTop: "16px" }}>
          {current > 0 && (
            <button className="next-button" onClick={onBack}>
              ← Terug
            </button>
          )}

          {isMultiSelect && (
            <button
              className="next-button"
              onClick={onNext}
              disabled={
                !answers[question.id] || answers[question.id].length === 0
              }
            >
              Volgende →
            </button>
          )}
        </div>

        {/* Divider */}
        <div className="progress-divider" />

        {/* Progress dots */}
        <div className="progress-dots">
          {Array.from({ length: total }).map((_, index) => (
            <span
              key={index}
              className={`dot ${
                index === current
                  ? "dot--active"
                  : index < current
                  ? "dot--done"
                  : ""
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
``
